import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-10 bg-black-background py-0 px-1.5 z-50 relative" }
const _hoisted_2 = { class: "container mx-auto max-w-screen-lg h-full" }
const _hoisted_3 = { class: "flex justify-between h-full px-5" }
const _hoisted_4 = { class: "text-gray-700 text-center flex items-center align-items cursor-pointer" }
const _hoisted_5 = { class: "flex justify-center w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-comfortaa text-2em text-center text-white my-auto" }, "a", -1)
const _hoisted_7 = { class: "text-gray-700 text-center flex items-center align-items" }
const _hoisted_8 = {
  key: 0,
  class: "flex"
}
const _hoisted_9 = { class: "flex items-center cursor-pointer text-black" }
const _hoisted_10 = { class: "min-w-28px w-28px h-28px box-border text-white" }
const _hoisted_11 = { class: "block m-0 w-full h-full" }
const _hoisted_12 = { class: "w-full h-full inline-flex flex-nowrap items-center justify-center text-lg rounded-50% bg-green-animeboxd" }
const _hoisted_13 = {
  key: 1,
  class: "h-full flex items-center"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://myanimelist.net/register.php?from=%2F",
  class: "font-bold text-sm rounded text-white w-20 h-full flex flex-col justify-center",
  target: "_blank"
}, " Sign Up ", -1)
const _hoisted_15 = { class: "h-full flex items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "white"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SearchBar = _resolveComponent("SearchBar")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, [
            _createVNode(_component_router_link, { to: '/' }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: "font-bold text-sm rounded text-white w-20 h-8",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
                }, " Sign Out "),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: '/profile/' + _ctx.user.id + '/' + _ctx.user.username,
                    class: "min-w-28px min-h-28px"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.user.username.charAt(0).toUpperCase()), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("button", {
                  type: "button",
                  class: "font-bold text-sm rounded text-white w-20 h-full",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveVerifier && _ctx.saveVerifier(...args)))
                }, " Log In "),
                _hoisted_14
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "font-bold text-sm rounded text-white w-auto h-auto ml-3 mb-1",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSearchBar && _ctx.toggleSearchBar(...args)))
            }, _hoisted_17)
          ])
        ])
      ])
    ]),
    _createVNode(_component_SearchBar)
  ]))
}